import React, { useState, useEffect } from "react";
import SumStory from '../../components/SumStory'
import SumStoryPerson from '../../components/SumStoryPerson'
import Story from '../../components/Story'
import PageStep from '../../components/PageStep'
import { Row, Col, Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom';
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import {Helmet} from "react-helmet";

const ActivitySummary = props => {
    const { activityId } = useParams();
    const [role, setRole] = useState('');
    const [currentTab, setCurrentTab] = useState('sumstory');
    const [topicId, setTopicId] = useState('');
    // const [finishedDate, setFinishedDate] = useState('');
    const [createDate, setCreateDate] = useState('');

    useEffect(() => {
        setRole(AuthService.getUserRole())
        UserService.getActivityDetail(activityId).then((res) => {
            if (res.data.data && res.data.data.topic) {
                const topic_id = res.data.data.topic.id
                setTopicId(topic_id)
                // setFinishedDate(res.data.data.finishedDate)
                setCreateDate(res.data.data.createdAt[0]+'-'+res.data.data.createdAt[1]+'-'+res.data.data.createdAt[2])
            }
        })
        // props.onChange({ 'backgroundColor': 'bg-blue' })
    })

    const changeTab = (tab) => {
        console.log(tab)
        setCurrentTab(tab)
    }

    return (
        <div>
            <Helmet>
                <title>สรุปกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวกประจำวัน - Mindsetmaker.co</title>
                <meta property="og:title"       content={`สรุปกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวกประจำวัน - Mindsetmaker.co`} />
                <meta property="og:description" content={`สรุปกิจกรรมค้นหาคุณค่าผ่านนิสัยเชิงบวก ประจำชั้น${AuthService.getCurrentUser().room.displayName} ${AuthService.getCurrentUser().domain.displayName}`} />
            </Helmet>
            {(role === 'teacher') &&
                <Row className="bg-white border-sdb-gray fix-top pb-0">
                    <Col xs={12} className="main-detail my-lg-3 ">
                        <PageStep step="4" />
                    </Col>
                    {/* <Col xs={12} className="ReportOverviewPage">
                        <div className="report-overview main-detail mb-3 w-100">
                            <div className="mb-3 btn-main-group  w-100 text-center">
                                <Button variant="report-menu m-2 py-md-1 btn-repot font-sarabun" onClick={() => changeTab('activity')} className={`${currentTab === 'activity' ? "btn-mm-danger font-weight-600" : "btn-mm-outline-danger"}`} >เรื่องราว</Button>
                                <Button variant="report-menu m-2 py-md-1 btn-repot font-sarabun" onClick={() => changeTab('sumstory')} className={`${currentTab === 'sumstory' ? "btn-mm-danger font-weight-600" : "btn-mm-outline-danger"}`} >คำตอบจากนักเรียน</Button>
                            </div>
                        </div>
                    </Col> */}
                </Row>
            }
            { topicId && (
                <Row className={`bg-lightness-blue activity ${(currentTab === 'activity') ? "" : "d-none"}`}>
                    <Col xs={12} className="main-detail mb-3 mt-5">
                        <Story topicId={topicId} showQuestion="1" hideStart="1" />
                    </Col>
                </Row>
            )}
            {/* for teacher */}
            <Row className={`bg-lightness-blue sum-activity text-center ${(currentTab === 'sumstory' && role === 'teacher') ? "" : "d-none"}`}>
                <Col xs={12} className="mb-3 mt-5">
                    {/* <SumStory hideHeader="1" summaryDateTitle="1" date={convertDate(finishedDate, 'datestring', 1)} activityId={activityId} /> */}
                    <SumStory hideHeader="1" summaryDateTitle="1" date={convertDate(createDate, 'datestring', 1)} activityId={activityId} />
                    <Row className="pb-3 py-md-3 mx-0">
                        <Col className="main-detail px-4">
                            <Button href="/activity" className="bluebtn d-inline py-1 py-md-2 px-3 font-weight-600 font-sarabun-bold">กลับหน้าหลัก</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>

            {/* for student */}
            <Row className={`bg-lightness-blue sum-activity text-center ${(role === 'student') ? "" : "d-none"}`}>
                <Col xs={12} className="mb-3 mt-5">
                    <SumStoryPerson hideHeader="1" summaryTitle="1" showBackTo="1" studentId={AuthService.getCurrentUserId()} date='activityDate' activityId={activityId} activityMode="activity-summary" />
                </Col>
            </Row>
        </div>
    );

    function convertDate(dateTime, formatDate = 'mobile', adjustDate = 0) {
        if (dateTime !== '') {
            if (adjustDate !== 0) {
                // dateTime = new Date(dateTime);
                // dateTime = dateTime.setDate(dateTime.getDate() + adjustDate);
                // console.log('dateTime');
                // console.log(dateTime);

                var day = new Date(dateTime);
                var tempDay = new Date(day);
                tempDay.setDate(day.getDate() + adjustDate);
                dateTime = tempDay;
            }

            var formattedDate = ('0' + dateTime.getDate()).slice(-2);
            var formattedMonth = ('0' + (dateTime.getMonth() + 1)).slice(-2);
            // Combine and format date string
            if (formatDate === 'mobile') {
                var formattedYear = dateTime.getFullYear().toString().substr(2, 2);
                return formattedMonth + '/' + formattedDate + '/' + formattedYear;
            } else if (formatDate === 'desktop') {
                return formattedMonth + '/' + formattedDate + '/' + dateTime.getFullYear().toString();
            } else if (formatDate === 'iso') {
                return dateTime.toISOString();
            } else if (formatDate === 'datestring') {
                var months_th = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",];
                var temp = dateTime.getFullYear() + 543;
                return dateTime.getDate() + ' ' + months_th[dateTime.getMonth()] + ' ' + temp;
            }

            return '';
        }
    }
};

export default ActivitySummary;